import TaboolaPixel from './TaboolaPixel';

export default TaboolaPixel;
